module.exports = __webpack_public_path__ + "static/media/intro.a5d12d5c.mp3";